import { VulnerabilitySeverity, VulnerabilityOrder } from '../types.esm.js';

const SEVERITY_COLORS = new Proxy(
  /* @__PURE__ */ new Map([
    [VulnerabilitySeverity.Critical, "#7D1007"],
    [VulnerabilitySeverity.High, "#C9190B"],
    [VulnerabilitySeverity.Medium, "#EC7A08"],
    [VulnerabilitySeverity.Low, "#F0AB00"],
    [VulnerabilitySeverity.None, "#3E8635"]
  ]),
  {
    get: (o, k) => o.has(k) ? o.get(k) : "#8A8D90"
  }
);
const vulnerabilitySummary = (layer) => {
  const summary = {};
  layer?.Features.forEach((feature) => {
    feature.Vulnerabilities?.forEach((vulnerability) => {
      const { Severity } = vulnerability;
      if (!summary[Severity]) {
        summary[Severity] = 0;
      }
      summary[Severity]++;
    });
  });
  const scanResults = Object.entries(summary).sort((a, b) => {
    const severityA = VulnerabilityOrder[a[0]];
    const severityB = VulnerabilityOrder[b[0]];
    return severityA - severityB;
  }).map(([severity, count]) => `${severity}: ${count}`).join(", ");
  return scanResults.trim() !== "" ? scanResults : "Passed";
};
const securityScanOrder = [
  "High",
  "Medium",
  "Low",
  "Passed",
  "Scanning",
  "Queued",
  "Unscanned",
  "Unsupported"
];
const capitalizeFirstLetter = (s) => {
  return s.charAt(0).toUpperCase() + s.slice(1);
};
const securityScanComparator = (ar, br, order = "desc") => {
  const a = vulnerabilitySummary(ar.securityDetails);
  const b = vulnerabilitySummary(br.securityDetails);
  const parseScan = (scan) => {
    const values = {
      High: 0,
      Medium: 0,
      Low: 0
    };
    scan.split(", ").forEach((part) => {
      const [key, value] = part.split(": ");
      if (values[key] !== void 0) {
        values[key] = parseInt(value, 10);
      }
    });
    return values;
  };
  const aParts = a.split(", ");
  const bParts = b.split(", ");
  const multiplier = order === "asc" ? 1 : -1;
  if (aParts.length >= 1 && bParts.length >= 1 && aParts[0] !== "Passed" && bParts[0] !== "Passed") {
    const aParsed = parseScan(a);
    const bParsed = parseScan(b);
    if (aParsed.High !== bParsed.High) {
      return (bParsed.High - aParsed.High) * multiplier;
    }
    if (aParsed.Medium !== bParsed.Medium) {
      return (bParsed.Medium - aParsed.Medium) * multiplier;
    }
    if (aParsed.Low !== bParsed.Low) {
      return (bParsed.Low - aParsed.Low) * multiplier;
    }
  }
  const finalAValue = capitalizeFirstLetter(
    ar.securityStatus === "scanned" ? aParts[0].split(":")[0] : ar.securityStatus ?? "scanning"
  );
  const finalBValue = capitalizeFirstLetter(
    br.securityStatus === "scanned" ? bParts[0].split(":")[0] : br.securityStatus ?? "scanning"
  );
  if (finalAValue === "Scanning" || finalBValue === "Scanning") return 1;
  return (securityScanOrder.indexOf(finalAValue) - securityScanOrder.indexOf(finalBValue)) * multiplier;
};

export { SEVERITY_COLORS, capitalizeFirstLetter, securityScanComparator, vulnerabilitySummary };
//# sourceMappingURL=utils.esm.js.map
